/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        var $grid = $('.posts')
          .isotope({
            itemSelector: '.post',
            layoutMode: 'packery',
            isInitLayout: false
          })
        $grid.isotope('on', 'layoutComplete', function (items) {
          var totalWidth = $('.posts').width()
          items.forEach(function (i) {
            var $el = $(i.element).removeClass('right').removeClass('left')
            if (i.position.x === 0) {
              $el.addClass('left')
            }
            if (i.position.x + i.rect.width > totalWidth * 0.75) {
              $el.addClass('right')
            }
          })
          loadHashchange()
        })
        $grid.isotope()

        var _hashchangeLoaded = false
        function loadHashchange () {
          if (_hashchangeLoaded) return
          _hashchangeLoaded = true

          $(window).hashchange(function () {
            var hash = window.location.hash.replace('#', '')
            var sel = hash === '' ? '*' : '.category-' + hash
            $grid.isotope({ filter: sel })
            if (hash === '') {
              $('article.i-1').removeClass('hide')
            } else {
              $('article.i-1').addClass('hide')
            }
          }).hashchange()
        }

        function articleLoad () {
          $('article.post').each(function () {
            if ($(this).hasClass('i-1')) {
              $('.post-categories li', this).each(function () {
                if ($('a', this).text() !== 'Breaking Wind'){
                  $(this).hide()
                }
              })

            // other breaking winds
            } else if ($(this).hasClass('category-breaking-wind')) {
              // take off the breaking wind category
              $('.post-categories li', this).each(function () {
                if ($('a', this).text() === 'Breaking Wind') {
                  $(this).hide()
                }
              })

              // randomly make small
              if (!$(this).data('done')) {
                if (Math.random() > 0.5) {
                  $(this).removeClass('category-breaking-wind').removeClass('format-standard').addClass('format-aside')
                }
                $(this).data('done', true)
                
              }
            }
          })
        }
        articleLoad()

        // lazy-load posts
        var _fullyLoaded = false
        var _loading = false
        var _page = 1
        $(window).scroll(function () {
          // lazy load
          var bottomDistance = $(window).scrollTop() + $(window).height() - $('body').height()
          if (!_fullyLoaded) { // for inital page load
            _fullyLoaded = true
            return
          }
          if (_fullyLoaded && bottomDistance > -500 && !_loading) {
            _loading = true
            _page++
            $('.posts').append("<div class='loading' />")
            var pieces = window.location.href.replace(window.location.hash, '').replace('#', '').split('?')
            var url = pieces[0].replace(/\/$/, '') + '/page/' + _page + (pieces[1] ? '?' + pieces[1] : '')
            $.ajax({
              url: url,
              success: function (html) {
                $('.loading').remove()
                var posts = $(html).find('.main > article')
                $grid.append(posts)
                articleLoad()
                $grid.isotope('appended', posts)
                $('body').trigger('post-load')
                _loading = false
              },
              error: function () {
                $('.loading').remove()
              }
            })
          }
        })


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
